import { ReactElement } from 'react';
import { SkeletonButton } from 'x-ui-design';
import './index.less';

export const ChangeThemeSkeleton = (): ReactElement => {
  return <SkeletonButton shape="round" className="ChangeThemeSkeleton" />;
};
